import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
export default {
  name: 'FileList2',
  components: {},
  data: function data() {
    return {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      uploadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      fileTabDatas: [],
      fileTableDatas: []
    };
  },
  methods: {
    getImage: function getImage(row) {
      var url = row.url;
      return this.uploadUrl + url;
    },
    handleClick: function handleClick(tab, event) {
      this.pageNo = 1;
      this.initTableData(tab.name);
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.fileTabDatas = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initDatas: function initDatas() {
      this.getEnumList('file_type');
    },
    initTableData: function initTableData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                pageNo: _this2.pageNo,
                pageSize: _this2.pageSize,
                type: type
              };
              _context2.n = 1;
              return api.GET_FILE_PAGE_LIST(par);
            case 1:
              res = _context2.v;
              _this2.fileTableDatas = res.body.datas;
              _this2.pageTotal = res.body.sumDataCount;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.initDatas();
  }
};